import $ from 'jquery';
import mdModal from 'ui/mdmodal';
import social from './social.js';

const CLASSES = {
    LINK: 'js-share-modal-link',
};

export default class ShareModal {
    constructor(url, params = {}) {
        this.url = url || location.href;
        this.params = params;
        this.inited = false;
    }

    show() {
        if (!this.modal) {
            this.modal = mdModal.add(
                {
                    title: this.params.title || 'Поделиться',
                    content: this.tempalte,
                    footer: {
                        buttons: [
                            {
                                text: 'Отменить',
                                classes: 'btn btn-ashed ui-modal-footer-btn',
                                onclick: () => {
                                    if (this.modal) {
                                        this.modal.close();
                                    }
                                },
                            },
                        ],
                    },
                },
                {
                    show: ::this.onShow,
                }
            );
        }

        this.modal.show();
    }

    onShow() {
        if (!this.modal || this.inited) {
            return;
        }

        this.inited = true;

        const content = $(this.modal.content());
        const link = content.find(`.${CLASSES.LINK}`);

        link.val(this.url);
        link.on('click', () => {
            link.select();
        });
        content.on('click', '.js-share', (e) => {
            const target = e.target;

            if (!target) {
                return;
            }

            social.share(this.url, target.getAttribute('data-social'));
        });
    }

    get tempalte() {
        return `<div>
                <strong>Поделиться страницей в социальной сети</strong>
                <div class="ui-modal-social">
                    <a class="js-share ui-modal-social-link
                        ui-modal-social-link-vk sf-vk-en" data-social="vk"></a>
                    <a class="js-share ui-modal-social-link
                        ui-modal-social-link-ok sf-odnoklassniki" data-social="od"></a>
<!--                    <a class="js-share ui-modal-social-link-->
<!--                        ui-modal-social-link-tw sf-twitter" data-social="tw"></a>-->
<!--                    <a class="js-share ui-modal-social-link-->
<!--                        ui-modal-social-link-fb sf-facebook" data-social="fb"></a>-->
                    <a class="js-share ui-modal-social-link
                        ui-modal-social-link-gp sf-gplus" data-social="gp"></a>
                    <a class="js-share ui-modal-social-link
                        ui-modal-social-link-fb sf-mailru" data-social="mm"></a>
                </div>

                <strong>Прямая ссылка</strong>
                <input
                    placeholder="Прямая ссылка"
                    value=""
                    class="ui-input ${CLASSES.LINK}"
                    readonly="readonly"
                    type="text"
                />
            </div>`;
    }
}
